import React from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import TabOrderGeneral from '../TabOrderGeneral';
import TabOrderInspections from '../TabOrderInspections';
import TabOrderDocuments from '../TabOrderDocuments';
import Divider from '../../../_common/components/Divider';
import OrderStatus from '../../../_common/components/OrderStatus';
import {useOrderDetailsUIOrderContext} from '../OrderDetailsUIOrderContext';
import ModalHeader from '../../../_common/components/ModalHeader';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from '../../../_common/components/VerticalTabs/styles.module.scss';

export default function VerticalTabs() {
  const {
    nextTabsEnabled,
    activeTab,
    setActiveTab,
    orderStatus,
    createTime
  } = useOrderDetailsUIOrderContext();
  const tabs = [
    {
      id: 'orderGeneral',
      label: 'פרטי הזמנה',
      content: <TabOrderGeneral/>,
      icon: '/media/common/Order.svg',
    },
    {
      id: 'orderInspections',
      label: 'דוחות',
      content: <TabOrderInspections/>,
      icon: '/media/common/Clipboard.svg',
      disabled: !nextTabsEnabled
    },
    {
      id: 'orderDocuments',
      label: 'מסמכים',
      content: <TabOrderDocuments/>,
      icon: '/media/common/File-plus.svg',
      disabled: !nextTabsEnabled
    },
  ];

  const current = tabs.find(t => t.id === activeTab);

  const handleTabClick = (tab) => {
    if (tab.disabled) return;
    setActiveTab(tab.id);
  };
  const hasCreateTime = nextTabsEnabled && createTime;
  const hasStatus = nextTabsEnabled && orderStatus;

  return (
    <div className={styles.container}>
      <div className={styles.sidebar}>
        {createTime && <div className={classNames(styles.dateContainer, 'badge')}>
          <div className="text-dark-75 font-weight-bolder font-size-h3 text-nowrap">
            {createTime ? dayjs(createTime).format('DD-MM-YYYY') : ''}
          </div>
        </div>
        }
        {hasCreateTime && <Divider customClassNames={'my-8'}/>}
        {hasStatus && <OrderStatus
          variant={'badge'} size={'xl'} statusID={orderStatus}
          customClassNames={'w-100'}
        />
        }
        {hasStatus && <Divider customClassNames={'my-8'}/>}
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={classNames(
              styles.tab,
              activeTab === tab.id && styles.active,
              tab.disabled && styles.disabled
            )}
            onClick={() => handleTabClick(tab)}
            disabled={tab.disabled}
          >
            <img className={styles.icon} src={toAbsoluteUrl(tab.icon)} alt="icon"/>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
      <div className={styles.content}>
        <ModalHeader header={current?.label} customClassnames={'p-4'}/>
        {current.content}
      </div>
    </div>
  );
}
